import React, { useContext } from 'react';
import styled, { css } from 'styled-components';

import { SectionContainer } from './common/SectionContainer';
import Title from './common/Title';
import Subtitle from './common/Subtitle';
import Paragraph from './common/Paragraph';
import { DarkModeContext } from './context/DarkModeContext';

import { SIZE } from './common/constants';

const Skills = () => {
  const { isDarkModeOn } = useContext(DarkModeContext);
  return (
    <SectionContainer id='skills'>
      <Title title='Skills'></Title>
      <SkillContainer>
        <Skill>
          <Subtitle subtitle='Programming'></Subtitle>
          {programmingSkills.map((item) => (
            <Paragraph text={item.name}></Paragraph>
          ))}
        </Skill>
        <Skill>
          <Subtitle subtitle='Tools'></Subtitle>
          {tools.map((item) => (
            <Paragraph text={item.name}></Paragraph>
          ))}
        </Skill>
        <Skill>
          <Subtitle subtitle='Design'></Subtitle>
          {designSkills.map((item) => (
            <Paragraph text={item.name}></Paragraph>
          ))}
        </Skill>
      </SkillContainer>
    </SectionContainer>
  );
};

export default Skills;

// 🎨 Styled Components
const SkillContainer = styled.div`
  display: flex;
  @media (max-width: ${SIZE.medium}) {
    flex-direction: column;
  }
`;

const Skill = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 2em 2em 2em 0;
  @media (max-width: ${SIZE.medium}) {
    flex-direction: column;
    padding: 2em 0;
  }
`;

const programmingSkills = [
  {
    name: 'HTML5 & CSS3',
  },
  {
    name: 'JavaScript with Node.js',
  },
  {
    name: 'React.js',
  },
  {
    name: 'Vue.js',
  },
  {
    name: 'Post CSS',
  },
  {
    name: 'Sass',
  },
  {
    name: 'Styled Components',
  },
  {
    name: 'Axios',
  },
  {
    name: 'SQL',
  },
  {
    name: 'Docker',
  },
  {
    name: 'Jasmine',
  },
];

// const langList = [
//   {
//     name: "Korean",
//     percent: "100",
//   },
//   {
//     name: "English",
//     percent: "90",
//   },
//   {
//     name: "German",
//     percent: "30",
//   },
// ];

const designSkills = [
  { name: 'Figma' },
  { name: 'Adobe Photoshop' },
  { name: 'Adobe Illustrator' },
  { name: 'Adobe Indesign' },
];

const tools = [
  {
    name: 'NPM/Yarn',
  },
  {
    name: 'Git',
  },
  {
    name: 'Github & Gitlab',
  },
  {
    name: 'VSCode',
  },
  {
    name: 'Sourcetree',
  },
  {
    name: 'Jira',
  },
  {
    name: 'Clubhouse',
  },
  {
    name: 'Cloudinary',
  },
  {
    name: 'Google Firebase',
  },
];
